import { useState } from 'react';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';

import { GlobalVariables } from '../../../globalVar';
import customAxios from '../../../utils/customAxios';
import { getToast } from '../../../utils/toastConfig';

const HEADERS = {
  headers: { Authorization: 'bearer ' + localStorage.getItem('token') },
};

export const DeleteModelModal = ({
  modelId,
  model,
  showModal,
  setShowModal,
  refreshData,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const handleClose = () => {
    setShowModal(false);
    refreshData();
  };
  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const response = await customAxios.delete(
        `${GlobalVariables.getURL()}models/${modelId}`,
        HEADERS,
      );
      if (response.status >= 200 && response.status < 300) {
        getToast({
          status: 'success',
          title: 'Modelo inactivado exitosamente en la base de datos.',
        });
        handleClose();
      }
    } catch (error) {
      console.log('Error deactivating model:', error);
      getToast({
        status: 'error',
        title: error.response?.data?.message || 'Error',
      });
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <Dialog open={showModal} maxWidth='sm' fullWidth onClose={handleClose}>
      <DialogTitle>
        <Typography className='inventory-movmodal-title'>
          ¿Desea inactivar este modelo?
        </Typography>
      </DialogTitle>
      <IconButton
        aria-label='close'
        onClick={handleClose}
        sx={{ position: 'absolute', right: 20, top: 20, width: 40, height: 40 }}
      >
        <FontAwesomeIcon icon={faTimes} />
      </IconButton>
      <DialogContent dividers>
        <Typography variant='h6'>
          <span style={{ marginRight: '20px', fontWeight: 'bold' }}>ID:</span>
          {modelId}
        </Typography>
        <Typography variant='h6'>
          <span style={{ marginRight: '20px', fontWeight: 'bold' }}>
            Nombre:
          </span>
          {model?.name || '-'}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant='text' disabled={isLoading} onClick={handleClose}>
          <Typography>Cancelar</Typography>
        </Button>
        <Button
          variant='contained'
          onClick={handleSubmit}
          disabled={isLoading || !modelId}
        >
          {isLoading ? (
            <CircularProgress size='2rem' />
          ) : (
            <Typography>Confirmar</Typography>
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
